import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef, useState } from "react";
import UploadSvg from "./icons/UploadSvg";
import DelSVG from "./icons/DelSVG";
import stl from "./FileUploader_V2.module.css";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
import { useTranslation } from "@i18n";
import { trackEvents } from "@/common/events/events";
import { CDN_LINK } from "@globalConfig";
import toast from "react-hot-toast";
import { api__deleteDoc } from "@/apis/orderTracking/deleteDocs";
import { getFileMimeType } from "@/utils/dom";
import LinkToFile from "@/common/HOCs/LinkToFile";
import useButtonLoading, { dispatchButtonLoading } from "@hooks/useButtonLoading";
var FileUploader_V2 = function FileUploader_V2(_ref) {
  var _details$step_desc, _dbFile$file, _details$step_desc2, _details$step_desc3;
  var g4_data = _ref.g4_data,
    onFileChange = _ref.onFileChange,
    dbFile = _ref.dbFile,
    details = _ref.details,
    deleteFileObject = _ref.deleteFileObject,
    deleteDocuments = _ref.deleteDocuments,
    orderId = _ref.orderId,
    buttonLoading = _ref.buttonLoading,
    isFinance = _ref.isFinance,
    setFileObjects = _ref.setFileObjects,
    isPreFilledData = _ref.isPreFilledData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    showDeletePopup = _useState[0],
    setShowDeletePopup = _useState[1];
  var _useState2 = useState(undefined),
    domInMemoryFile = _useState2[0],
    setDomInMemoryFile = _useState2[1];
  var _useState3 = useState(false),
    resetInput = _useState3[0],
    setResetInput = _useState3[1];
  var _useState4 = useState(false),
    isclientUpload = _useState4[0],
    setIsclientUpload = _useState4[1];
  var loading = useButtonLoading();
  var inputRef = useRef();
  var _useState5 = useState((dbFile === null || dbFile === void 0 ? void 0 : dbFile.status) === "rejected" ? dbFile !== null && dbFile !== void 0 && dbFile.reject_reason ? dbFile === null || dbFile === void 0 ? void 0 : dbFile.reject_reason : t("re_upload_image", {
      ns: "web_tracking"
    }) : undefined),
    hasError = _useState5[0],
    setHasError = _useState5[1];
  var handleDeleteClick = function handleDeleteClick() {
    //client side
    if ((dbFile === null || dbFile === void 0 ? void 0 : dbFile.file) === null || (dbFile === null || dbFile === void 0 ? void 0 : dbFile.status) === "rejected" && dbFile !== null && dbFile !== void 0 && dbFile.file) {
      setResetInput(true);
      setDomInMemoryFile(undefined);
      deleteFileObject(dbFile);
      deleteDocuments(dbFile);
      setShowDeletePopup(false);
    } else {
      dispatchButtonLoading(true);
      api__deleteDoc(dbFile === null || dbFile === void 0 ? void 0 : dbFile.document_key, orderId, isFinance).then(function (res) {
        setDomInMemoryFile(undefined);
        deleteFileObject(dbFile);
        setFileObjects({});
        deleteDocuments(dbFile);
        setShowDeletePopup(false);
      })["catch"](function (error) {
        toast.dismiss();
        toast.error(error.message);
      })["finally"](function () {
        dispatchButtonLoading(false);
      });
    }
  };
  var handleFileChange = function handleFileChange(e, field) {
    setHasError(undefined);
    var selectedFile = e.target.files[0];
    setIsclientUpload(true);
    if (selectedFile) {
      // Check file size (5 MB)
      if (selectedFile.size > 5 * 1024 * 1024) {
        var errorDescription = t("validation_file_size_exceed_5_mb", {
          ns: "web_tracking"
        });
        setHasError(errorDescription);
        trackEvents("validation_error", {
          document_id_type: field === null || field === void 0 ? void 0 : field.path,
          error_description: errorDescription
        });
        return;
      }

      // Check file type
      var allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
      if (!allowedTypes.includes(getFileMimeType(selectedFile))) {
        var _errorDescription = t("accepted_extensions_pdf_jpeg_png", {
          ns: "web_tracking"
        });
        setHasError(_errorDescription);
        trackEvents("validation_error", {
          document_id_type: field === null || field === void 0 ? void 0 : field.path,
          error_description: _errorDescription
        });
        return;
      }

      // Create a new File object to prevent ERR_UPLOAD_FILE_CHANGED
      // This ensures the file reference remains valid even if the input is cleared
      var clonedFile = new File([selectedFile], selectedFile.name, {
        type: selectedFile.type,
        lastModified: selectedFile.lastModified
      });
      onFileChange(clonedFile, field);
      setDomInMemoryFile(clonedFile);
    }
  };
  useEffect(function () {
    resetInput && setResetInput(false);
  }, [resetInput]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: [stl.fileUploaderContainer, domInMemoryFile != undefined ||
    // (field?.status !== "rejected" && field?.file && field?.status !== "approved")
    (dbFile === null || dbFile === void 0 ? void 0 : dbFile.status) !== "rejected" && dbFile !== null && dbFile !== void 0 && dbFile.file ? stl.hasFile : undefined, dbFile !== null && dbFile !== void 0 && dbFile.file && (dbFile === null || dbFile === void 0 ? void 0 : dbFile.status) === "approved" ? stl.hasFileGreen : undefined, domInMemoryFile != undefined ? stl.hasFileGreen : undefined, (dbFile === null || dbFile === void 0 ? void 0 : dbFile.status) === "rejected" && domInMemoryFile == undefined || hasError ? stl.hasErrorInput : "", buttonLoading ? stl.pointerEvents : ""].join(" ")
  }, /*#__PURE__*/React.createElement("label", null, dbFile.label), /*#__PURE__*/React.createElement("div", {
    className: [stl.upperwrpper, domInMemoryFile !== undefined || (dbFile === null || dbFile === void 0 ? void 0 : dbFile.status) !== "rejected" && dbFile !== null && dbFile !== void 0 && dbFile.file ? stl.smallerSize : "", (dbFile === null || dbFile === void 0 ? void 0 : dbFile.status) === "approved" && (details === null || details === void 0 ? void 0 : (_details$step_desc = details.step_desc) === null || _details$step_desc === void 0 ? void 0 : _details$step_desc.status) === "rejected" ? stl.readingOnly : ""
    //showFilePrev ? stl.relocateUpload : undefined,
    ].join(" ")
  }, !resetInput && /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    type: "file",
    accept: ".jpg, .jpeg, .png, .pdf",
    onChange: function onChange(e) {
      handleFileChange(e, dbFile);
    },
    placeholder: dbFile.placeholder,
    name: dbFile === null || dbFile === void 0 ? void 0 : dbFile.name_en
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.nameContainer, " ")
  }, domInMemoryFile !== null && domInMemoryFile !== void 0 && domInMemoryFile.name ? /*#__PURE__*/React.createElement("span", {
    className: stl.name
  }, domInMemoryFile === null || domInMemoryFile === void 0 ? void 0 : domInMemoryFile.name) : (dbFile === null || dbFile === void 0 ? void 0 : dbFile.status) !== "rejected" && dbFile !== null && dbFile !== void 0 && dbFile.file ? /*#__PURE__*/React.createElement("span", {
    className: stl.name
  }, dbFile === null || dbFile === void 0 ? void 0 : (_dbFile$file = dbFile.file) === null || _dbFile$file === void 0 ? void 0 : _dbFile$file.split("?")[0].split("/").slice(-3).join("/")) : /*#__PURE__*/React.createElement("span", {
    className: stl.placeholder
  }, dbFile === null || dbFile === void 0 ? void 0 : dbFile.placeholder), (dbFile === null || dbFile === void 0 ? void 0 : dbFile.status) === "approved" && (details === null || details === void 0 ? void 0 : (_details$step_desc2 = details.step_desc) === null || _details$step_desc2 === void 0 ? void 0 : _details$step_desc2.status) === "rejected" ? "" : domInMemoryFile !== undefined || (dbFile === null || dbFile === void 0 ? void 0 : dbFile.status) === "pending" && dbFile !== null && dbFile !== void 0 && dbFile.file ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkToFile, {
    dbFile: dbFile,
    setShowDeletePopup: setShowDeletePopup,
    originalInputRef: inputRef,
    stepStatus: details === null || details === void 0 ? void 0 : (_details$step_desc3 = details.step_desc) === null || _details$step_desc3 === void 0 ? void 0 : _details$step_desc3.status,
    g4_data: g4_data,
    fileUri: dbFile === null || dbFile === void 0 ? void 0 : dbFile.file,
    domInMemoryFile: domInMemoryFile,
    renderFunc: function renderFunc(label, onClick) {
      return /*#__PURE__*/React.createElement("span", {
        className: stl.showDoc,
        onClick: onClick
      }, label);
    }
  }), (!isPreFilledData || (dbFile === null || dbFile === void 0 ? void 0 : dbFile.status) === "rejected") && /*#__PURE__*/React.createElement("span", {
    className: stl.icon
  }, /*#__PURE__*/React.createElement(DelSVG, {
    onClick: function onClick() {
      setShowDeletePopup(true);
    }
  }))) : /*#__PURE__*/React.createElement("span", {
    className: stl.icon
  }, /*#__PURE__*/React.createElement(UploadSvg, null)))), hasError && /*#__PURE__*/React.createElement("span", {
    className: stl.hasErrSpan
  }, hasError)), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    noX: true,
    showXMob: true,
    className: stl.BottomSheetPopup,
    show: showDeletePopup,
    onClose: function onClose() {
      return setShowDeletePopup(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.popupContent
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/finance_delete.svg",
    alt: "delete"
  }), /*#__PURE__*/React.createElement("strong", null, t("sure_want_delete_document", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", null, t("validation_cannot_proceed_next_step_until", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.buttonsCtaContainer
  }, /*#__PURE__*/React.createElement(SubmitButton, {
    onClick: function onClick() {
      setShowDeletePopup(false);
      handleDeleteClick();
      setDomInMemoryFile(undefined);
    },
    loading: loading,
    disabled: loading,
    className: stl.ctaButton
  }, t("delete_document", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement(SubmitButton, {
    onClick: function onClick() {
      return setShowDeletePopup(false);
    },
    loading: loading,
    disabled: loading,
    className: stl.cancelButton
  }, t("return", {
    ns: "web_tracking"
  }))))));
};
export default FileUploader_V2;